import { ApiDOMError } from '@swagger-api/apidom-error';
class JsonSchema$anchorError extends ApiDOMError {}
export default JsonSchema$anchorError;